<template>
    <div class="modal fade" id="modalCreateRecepcion" tabindex="-1" 
      role="dialog" aria-labelledby="createModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="eventoSeleccionadoRecepcion">
          <div class="modal-header">
            <h5 class="modal-title" id="createModalLabel">Crear Recepcion</h5>
            <button type="button" class="btn btn-danger" @click="closeCrearRecepcion()"><i class="fas fa-times"></i></button>
          </div>
          <hr>
          <div class="row mx-4 mt-4">
            <div class="col-6 text-left">
              <h6 class="font-weight-bold">
                Recepcionar
              </h6>
            </div>
            <div class="col-6 text-right">
              <h6 class="font-weight-bold text-dark">
                ID - {{ eventoSeleccionadoRecepcion.id.toLocaleString("en-GB") }}
              </h6>
            </div>
            <div class="mt-2 mx-2">
              <p class="">
                {{ 
                  eventoSeleccionadoRecepcion.proveedor + " - " + eventoSeleccionadoRecepcion.proveedor_obj.nombre
                }}
              </p>
              <p class="" style="margin-top: -15px">
                {{ eventoSeleccionadoRecepcion.fecha_de | moment("DD-MM-YYYY") }}
                &nbsp;/&nbsp;
                {{ 
                  eventoSeleccionadoRecepcion.fecha_de | moment("hh:mm a") 
                }} 
                  - 
                {{
                  eventoSeleccionadoRecepcion.fecha_a | moment("hh:mm a") 
                }}
              </p>
            </div>
          </div>
          <hr>
          <div class="row mx-2 mt-4">
            <div class="col-12 text-center">
              <h5 class="font-weight-bold">
                Asignación de Rampa
              </h5>
            </div>
            <div class="my-2 col-12">
              <div class="text-center">
                
                <div class="row d-flex justify-content-center my-3">
                  <div class="input-group input-group-lg mx-3">
                    <input 
                      class="form-control" 
                      placeholder="Barra de Estación" 
                      v-model="searchbarra"
                      type="text"
                    />
                    <button 
                      @click="getBarraEstacion()" 
                      class="btn btn-success px-3"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mx-0">
            <div class="col-12 mb-3">
              <div class="modal-footer">
                <button :disabled="!isSelected" @click="cancelarEvento(eventoSeleccionadoRecepcion)" class="btn btn-md btn-danger btn-block">
                  Cancelar
                </button>
                <button @click="closeCrearRecepcion()" type="button" class="btn btn-secondary">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  inject: {
    refreshAgenda: {
      from: 'refreshAgenda',
      default: () => {}
    },
  },
  mounted() {
  },
  props: {
    eventoSeleccionadoRecepcion: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isSelected: false,
      searchbarra: ""
    }
  },
  watch: {
    searchbarra(newVal) {
      if (newVal.length > 17) {
        // Eliminar "01" si está al inicio
        if (newVal.startsWith("01")) {
          newVal = newVal.substring(2);
        }
        // Eliminar el último carácter
        newVal = newVal.slice(0, -1);
        // Asignar el nuevo valor a searchbarra
        this.searchbarra = newVal;
      }
      this.searchbarra = newVal;
    },
  },
  methods: {
    /**
     * $("#modalCreateRecepcion").modal("show");
     * 
     * Método que Dispara el cierre y apertura de los modales.
     */
    closeCrearRecepcion() {
      let self = this;
      self.selectedRampa = "";
      self.isSelected = false;
      $("#modalCreateRecepcion").modal("hide");
    },

    /**
     * Método que obtiene la posicion de estacion
     * según su barra
     */
    getBarraEstacion() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar Estación de Carga/Descarga",
        "¿Esta Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "agenda-proveedores",
            self.seleccionada.id,
            "asignar_estacion",
            {
              barra: self.barra,
              tienda: self.seleccionada.tienda.codigo,
            }
          )
            .then((response) => {
              self.cleanErrors();
              Notifications.alert.success(
                "Asignar carrito",
                "Asignar carrito correctamente"
              );
              $("#modalAggCarrito").modal("hide");
              self.seleccionar(self.seleccionada.id);
              self.barra = "";
              self.cleanErrors();
            })
            .catch((error) => {
              self.barra = "";
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error("Asignar carrito", error.response.data.detail);
              }
            });
        }
      );
    },

    /**
     * Método que nos permitre cancelar el evento pasado
     * en base a una razón de cancelacion.
     */
     cancelarEvento(det) {
      let self = this;
      console.log("evento cancelado: ", det)
      console.log("razon de cancelacion: ", self.selectedRampa);
      Notifications.alert.confirm(
        "Cancelar Evento",
        "¿Desea cancelar el evento planificado?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "agenda-proveedores",
            det.id,
            "cancelar_agenda",
            {
              motivo_cancelacion: self.selectedRampa,
            }
          ).then((response) => {
            self.$toast.success(response.data.detail,"Éxito",{position: 'topRight'});
            self.refreshAgenda();
            self.selectedCancelacion = "";
            self.isSelected = false;
            $("#modalDeleteEvento").modal("hide");
          });
        }
      );
    },

  }
}
</script>
